import { withWindow } from '@shared/utils/withWindow';
import { config } from '@static/js/joy';

export const performFullPageRedirect = (path: string) => {
  withWindow(global => {
    global.location.href = global.location.origin + path;
  });
};

// Encode `prev` via searchParams to avoid a double-`?` when the path already contains a query string.
export const buildAuthUrl = (route: '/login' | '/signup', returnPath: string): string => {
  const url = new URL(route, config.clientUri);
  url.searchParams.set('prev', returnPath);
  return url.href;
};

export const buildReturnPath = (loc: { pathname: string; search: string; hash: string }): string => `${loc.pathname}${loc.search}${loc.hash}`;
